import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const LabourSales = {
	name: NAME,
	apiProvider,
	router,
};
